import {Modal} from "antd";
import styled from "styled-components";

export const StyledQueueModal = styled(Modal)`
    @media (max-width: 768px) {
        max-width: 100% !important;
        width: 100% !important;
        margin: 0 !important;
        top: 0 !important;
        padding-bottom: 0;

        .ant-modal-content {
            border-radius: 0;
            height: 100vh;
            display: flex;
            flex-direction: column;
        }

        .ant-modal-header {
            border-radius: 0;
            padding: 12px 16px;
            flex-shrink: 0;
        }

        .ant-modal-body {
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 12px;
            -webkit-overflow-scrolling: touch;
        }

        .ant-modal-close-x {
            width: 48px;
            height: 48px;
            line-height: 48px;
            font-size: 20px;
        }

        .ant-row {
            margin-left: 0 !important;
            margin-right: 0 !important;
        }

        .ant-table-wrapper {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }

        .ant-table {
            font-size: 12px;
        }

        .ant-table-thead > tr > th,
        .ant-table-tbody > tr > td {
            padding: 8px 6px;
        }

        .ant-descriptions-bordered .ant-descriptions-view table {
            display: block !important;
            width: 100% !important;
        }

        .ant-descriptions-bordered .ant-descriptions-view table > tbody {
            display: block !important;
        }

        .ant-descriptions-bordered .ant-descriptions-row {
            display: flex !important;
            flex-direction: column !important;
        }

        .ant-descriptions-bordered .ant-descriptions-row > th,
        .ant-descriptions-bordered .ant-descriptions-row > td {
            display: block !important;
            width: 100% !important;
            border-right: none !important;
            padding: 10px 12px !important;
        }
    }
`;

export const CourierSection = styled.div`
    margin-top: 16px;
    margin-bottom: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    overflow: hidden;
`;

export const CourierSectionRow = styled.div`
    padding: 10px 16px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    gap: 8px;

    &:last-child {
        border-bottom: none;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        padding: 10px 12px;
    }
`;

export const CourierSectionLabel = styled.span`
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    white-space: nowrap;
    min-width: 120px;

    @media (max-width: 768px) {
        min-width: unset;
        margin-bottom: 4px;
    }
`;

export const CourierButtonGroup = styled.div`
    display: flex;
    gap: 8px;
    width: 100%;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;
